// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs {
    display: flex;
    flex-direction: row;
    background-color: white;
    height: 40px;
    border-radius: 15px;
    width: 100%;
    margin-top: 16px;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;
}

.tab {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    width: 320px;
    background-color: white;
    text-align: center;
    padding: 0;
    cursor: pointer;
}

.tab:not(:last-child) {
    position: relative;
}

.tab:not(:last-child)::after {
    content: "";
    position: absolute;
    right: -5px;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    height: 60%;
    background-color: lightsteelblue;
}

.tab:hover {
    background-color: #f0f0f0;
}

.tab.active {
    text-decoration: underline;
    text-decoration-color: #0073e6;
    text-decoration-thickness: 4px;
    text-underline-offset: 5px;
    background-color: white;
}

.tab-content {
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    max-height: 80vh;
    overflow-y: auto;
}

.dropDownContainer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 5px;
    width: 100%;
}

.customSelect {
    width: 300px;
    padding: 8px;
    font-size: 12px;
    border: 1px solid #0A74DA;
    font-weight: bold;
    background-color: white;
    border-radius: 5px;
    cursor: pointer;
}

.customSelect.disabled {
    color: grey;
    cursor: not-allowed;
}

.customSelect.enabled {
    color: #0A74DA;
}

.under-construction {
    font-weight: bold;
    color: #ff6f61;
    background-color: #5a6d85;
    padding: 16px;
    border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/dcFileUpload/DCFileUpload.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,8BAA8B;IAC9B,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,kBAAkB;AACtB","sourcesContent":[".tabs {\n    display: flex;\n    flex-direction: row;\n    background-color: white;\n    height: 40px;\n    border-radius: 15px;\n    width: 100%;\n    margin-top: 16px;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 5px;\n}\n\n.tab {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 40px;\n    width: 320px;\n    background-color: white;\n    text-align: center;\n    padding: 0;\n    cursor: pointer;\n}\n\n.tab:not(:last-child) {\n    position: relative;\n}\n\n.tab:not(:last-child)::after {\n    content: \"\";\n    position: absolute;\n    right: -5px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 1px;\n    height: 60%;\n    background-color: lightsteelblue;\n}\n\n.tab:hover {\n    background-color: #f0f0f0;\n}\n\n.tab.active {\n    text-decoration: underline;\n    text-decoration-color: #0073e6;\n    text-decoration-thickness: 4px;\n    text-underline-offset: 5px;\n    background-color: white;\n}\n\n.tab-content {\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    max-height: 80vh;\n    overflow-y: auto;\n}\n\n.dropDownContainer {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    margin-bottom: 5px;\n    width: 100%;\n}\n\n.customSelect {\n    width: 300px;\n    padding: 8px;\n    font-size: 12px;\n    border: 1px solid #0A74DA;\n    font-weight: bold;\n    background-color: white;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.customSelect.disabled {\n    color: grey;\n    cursor: not-allowed;\n}\n\n.customSelect.enabled {\n    color: #0A74DA;\n}\n\n.under-construction {\n    font-weight: bold;\n    color: #ff6f61;\n    background-color: #5a6d85;\n    padding: 16px;\n    border-radius: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
